<kal-table #tableComponent
           [columns]="columns"
           [dataSource]="formArray.controls"
           actionable>
    <tr *kalHeaderRowDef kal-header-row></tr>

    <td *kalBodyCell="'IdCritere' let row">
        <kal-select [formControl]="row.get('IdCritere')">
            <kal-option *ngFor="let criterion of paramCriteriaList" [value]="criterion.Id">
                {{criterion.Libelle}}
            </kal-option>
        </kal-select>
    </td>

    <td *kalBodyCell="'IdOperateur' let row">
        <kal-select [formControl]="row.get('IdOperateur')">
            <kal-option *ngFor="let operator of getOperatorList(row.get('IdCritere').value)" [value]="operator.Id">{{operator.Libelle}}</kal-option>
        </kal-select>
    </td>

    <td *kalBodyCell="'Valeur' let row">
        <app-shared-advanced-rule-criterion-value-control [criterionId]="row.get('IdCritere').value"
                                                            [formControl]="row.get('Valeur')">
        </app-shared-advanced-rule-criterion-value-control>
    </td>


    <ng-container [kalColumn]="tableComponent.actionColumnName">
        <td *kalBodyCell="let row; let index=index">

            <div>
                <kal-button (click)="stopPropagation($event)"
                            [kalMenuTriggerFor]="actionsMenu"
                            kalTheme="tertiary">
                    <kal-icon>more_horiz</kal-icon>
                </kal-button>

                <kal-menu #actionsMenu>
                    <kal-option (selectionChange)="removeLine(index)">Supprimer</kal-option>
                </kal-menu>

            </div>

        </td>
    </ng-container>


</kal-table>

<app-shared-icon-button (click)="addParameterLine()"
                        [disabled]="formArray.invalid">
    Ajouter une ligne
</app-shared-icon-button>

